import { FC } from 'react'
import { Box, List, ListItemButton, ListItemText, Typography, Paper } from '@mui/material'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import { xxllncColor } from '../../layout/themes'

interface GebiedNode {
  code: string
  naam: string
}

interface Props {
  gemeenteNaam: string
  nodes: GebiedNode[]
  selectedCode: string
  onSelect: (code: string) => void
}

const GebiedTreeview: FC<Props> = ({ gemeenteNaam, nodes, selectedCode, onSelect }) => {
  if (nodes.length === 0) {
    return (
      <Paper variant="outlined" sx={{ p: 2 }}>
        <Typography variant="body2" color="textSecondary">
          Geen gebied-indeling beschikbaar voor deze gemeente. Importeer eerst gebied-data
          via Beheer &rarr; Gebiedsindeling.
        </Typography>
      </Paper>
    )
  }

  return (
    <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
      <Box
        sx={{
          px: 2,
          py: 1.5,
          backgroundColor: xxllncColor.opDark10,
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        <Typography
          variant="overline"
          sx={{ fontWeight: 600, letterSpacing: 0.8, color: xxllncColor.dark100 }}
        >
          Gebieden &mdash; {gemeenteNaam}
        </Typography>
      </Box>
      <List dense disablePadding>
        <ListItemButton
          selected={selectedCode === ''}
          onClick={() => onSelect('')}
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <ListItemText
            primary={`${gemeenteNaam} (${nodes.length})`}
            primaryTypographyProps={{ fontWeight: 600, fontSize: 13 }}
          />
        </ListItemButton>
        {nodes.map((node) => (
          <ListItemButton
            key={node.code}
            selected={selectedCode === node.code}
            onClick={() => onSelect(node.code)}
            sx={{ pl: 4 }}
          >
            <LocationOnIcon
              fontSize="small"
              sx={{ mr: 1, color: xxllncColor.orange100, fontSize: 14 }}
            />
            <ListItemText
              primary={`${node.code} — ${node.naam}`}
              primaryTypographyProps={{ fontSize: 13 }}
            />
          </ListItemButton>
        ))}
      </List>
    </Paper>
  )
}

export default GebiedTreeview
